document.addEventListener('DOMContentLoaded', () => {
    const button = document.getElementById('back-to-top');
    const header = document.getElementById('back-to-top-trigger');

    const headerBottom = header.getBoundingClientRect().top + window.scrollY + header.offsetHeight;

    window.addEventListener('scroll', () => {
        if (window.scrollY > headerBottom) {
            button.classList.add('show');
        } else {
            button.classList.remove('show');
        }
    });

    button.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
});
